import script from "./LessonLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonLibrary.vue?vue&type=script&setup=true&lang=js"

import "./LessonLibrary.vue?vue&type=style&index=0&id=8a3f9532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a3f9532"]])

export default __exports__